import { Form, Input, Switch } from 'antd'
import { t } from 'i18next'
import React from 'react'
import { TemplatePurposeSelect } from './template-purpose-select'
import { TemplateBubble } from './template-bubble'
import { useAuth } from '../../auth'
import { PRIVATE_MESSAGE_TEMPLATE } from '../../user/permission'

export function MessageTemplateFormFields() {
    const body: string = Form.useWatch('body') ?? ''
    const { can } = useAuth()
    const canManagePrivateTemplates = can(PRIVATE_MESSAGE_TEMPLATE)

    return (
        <>
            <Form.Item
                name="purpose"
                label={t('Purpose')}
                required
            >
                <TemplatePurposeSelect />
            </Form.Item>
            <Form.Item
                name="title"
                label={t('Title')}
                required
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="body"
                label={t('Body')}
                required
            >
                <Input.TextArea autoSize={{ minRows: 3, maxRows: 16 }} />
            </Form.Item>
            {body.trim() ? (
                <Form.Item label={t('Preview')}>
                    <TemplateBubble
                        body={body}
                        className="text-sm"
                    />
                </Form.Item>
            ) : null}
            {canManagePrivateTemplates ? (
                <Form.Item
                    name="public"
                    label={t('Public')}
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            ) : null}
        </>
    )
}
